import { createApi, fetchBaseQuery, retry, FetchArgs } from "@reduxjs/toolkit/query/react";
import { AUTHENTICATION } from "../../constants";
import { nullUndefinedEmptyCheck } from "../../utils/helper";
import { loader } from "./staticReducer";
import { store } from './../store/index';

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_BACKEND_API_URL,
    prepareHeaders: async (headers) => {
        const accessToken = sessionStorage.getItem(AUTHENTICATION.SHARED.ACCESS_TOKEN);
        if (nullUndefinedEmptyCheck(accessToken)) {
            headers.set("Authorization", `Bearer ${accessToken}`);
        }
        headers.set("Content-type", "application/json");
        return headers;
    },
})


const staggeredBaseQueryWithBailOut = retry(
    async (args: string | FetchArgs, api, extraOptions) => {
        console.log(api)
        if (api.endpoint !== 'notificationStatus') api.dispatch(loader(true));
        let result = await baseQuery(args, api, extraOptions)
        if (result) {
            api.dispatch(loader(false));
            if (result?.error) { }
        }
        return result
    },
    {
        maxRetries: 0,
    }
);

export const baseApi = createApi({
    reducerPath: "baseApiReducer",
    baseQuery: staggeredBaseQueryWithBailOut,
    tagTypes: ["manageDepartment", "manageEmployee", 'manageIssue', 'dashboard', "manageAdmin", "notification", 'profilePage'],
    endpoints: () => ({}),
});